import React from "react";
import { fullName } from "../data/dishes";

export default function FoodImage({ dish, className = "", alt, animate = false }) {
  return (
    <img
      className={`ro-food ${animate ? "ro-food--float" : ""} ${className}`}
      src={dish.image}
      alt={alt === undefined ? fullName(dish) : alt}
      width="600"
      height="600"
    />
  );
}
